import {useQuery, UseQueryOptions} from "@tanstack/react-query";

export function useDefaultQuery<TData = unknown, TError = unknown>(props: Readonly<UseQueryOptions<TData, TError>>) {
    return useQuery<TData, TError>({
        ...props
    });
}